export const addDynamicTitle = () => {
    const title = document.getElementById("lp-headline-city");

    if (title) {
        title.textContent += " no Porto";
    }

    // later to add other clinics
    // if (utmParams?.utm_term) {
    //     const searchKeyword = utmParams.utm_term.toLowerCase().trim();  
    // }
};
